module.exports = __webpack_public_path__ + "static/media/age_is_a_funny_thing.8996561d.webp";